import { render, staticRenderFns } from "./ProveedorPantalla.vue?vue&type=template&id=05405f08&"
import script from "./ProveedorPantalla.vue?vue&type=script&lang=ts&"
export * from "./ProveedorPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('05405f08', component.options)
    } else {
      api.reload('05405f08', component.options)
    }
    module.hot.accept("./ProveedorPantalla.vue?vue&type=template&id=05405f08&", function () {
      api.rerender('05405f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Proveedor/ProveedorPantalla.vue"
export default component.exports